import { Component, ElementRef } from '@angular/core';
import { cloneDeep } from 'lodash';
import { environment } from 'src/environments/environment';
import { ComponentsService } from '../../services/components.service';
import { LayoutEditorBase } from '../layout-editor-base/layout-editor.base';
import { AttributeDataService } from '../../services/attribute-data.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { TemplateEditorUtilsService } from '../../services/template-editor-utils.service';
import { LayoutHugBoxService } from '../services/layout-hug-box.service';

@Component({
  selector: 'template-component-layout-weather',
  templateUrl: './layout-weather.component.html',
  styleUrls: ['./layout-weather.component.scss'],
  standalone: false,
})
export class LayoutWeatherComponent extends LayoutEditorBase {
  protected readonly layoutComponent = 'rise-layout-weather';

  LayoutType = ComponentsService.LAYOUTS_MAP['rise-layout-weather']; // make layout types available in template
  public scale: string;
  public daysToShow: number;
  public iconStyle: string;
  public color: string;
  public backgroundColor: string;
  public canEditCompany: boolean;
  public hasValidAddress: boolean;
  private componentServices: any;

  constructor(
    private elementRef: ElementRef,
    private componentsService: ComponentsService,
    private attributeDataService: AttributeDataService,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    private templateEditorUtils: TemplateEditorUtilsService,
    private layoutHugBoxService: LayoutHugBoxService,
  ) {
    super();

    this.canEditCompany = this.userStateService.hasRole('ua');

    var company = this.companyStateService.getCopyOfSelectedCompany(true);
    this.hasValidAddress = !!(
      company.postalCode ||
      (company.city && company.country)
    );

    this.componentsService.registerDirective({
      type: 'rise-layout-weather',
      element: this.elementRef.nativeElement,
      show: (options?) => {
        this.componentId = this.componentsService.selected.id;

        this.load();
      },
      getLabel: (componentId: string): string => {
        // TODO: temporary
        return 'Weather';
      },
      getName: (componentId: string): string => {
        // TODO: temporary
        return 'Weather';
      },
    });
  }

  load() {
    const defaultAttributes =
      this.componentsService.getSelectedDirective().defaultAttributes;
    const defaultLayout = cloneDeep(defaultAttributes?.layout || {});
    const defaultServices = cloneDeep(defaultAttributes?.services || []);

    const componentLayout =
      this.attributeDataService.getAvailableAttributeData(
        this.componentId,
        'layout',
      ) || defaultLayout;
    const componentServices =
      this.attributeDataService.getAvailableAttributeData(
        this.componentId,
        'services',
      ) || defaultServices;

    // account for situation when "layout" and "services" are set as JSON strings in html template
    this.componentLayout = this.templateEditorUtils.safeParseJson(
      componentLayout,
      defaultLayout,
    );
    this.componentServices = this.templateEditorUtils.safeParseJson(
      componentServices,
      defaultServices,
    );

    const layoutAttributes = this.componentLayout?.attributes || {};

    this.loadLayoutSelection(this.LayoutType.CURRENT);
    this.scale = layoutAttributes.scale || 'F';
    this.daysToShow = layoutAttributes.daysToShow || 4;
    this.iconStyle = layoutAttributes.iconStyle || 'color';
    this.color = layoutAttributes.color || 'rgba(125,125,125,1)';
    this.backgroundColor =
      layoutAttributes.backgroundColor || 'rgba(0,81,171,0.8)';

    // if environment is not defined, then this is a new component
    // re-save all setting including environment
    const environment = this.attributeDataService.getAttributeData(
      this.componentId,
      'environment',
    );
    if (!environment) {
      this.save();
    }
  }

  save() {
    this.applyLayoutSelection();
    this.componentLayout.attributes = {
      scale: this.scale,
      daysToShow: this.templateEditorUtils.intValueFor(this.daysToShow, 4),
      iconStyle: this.iconStyle,
      color: this.color,
      backgroundColor: this.backgroundColor,
    };

    if (
      !Array.isArray(this.componentServices) ||
      this.componentServices.length === 0
    ) {
      this.componentServices = [{}];
    }
    this.componentServices[0].attributes = {
      scale: this.scale,
    };

    this.attributeDataService.setAttributeData(
      this.componentId,
      'layout',
      this.componentLayout,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'services',
      this.componentServices,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'environment',
      environment.production ? 'prod' : 'test',
    );
  }

  setScale(scale: string) {
    this.scale = scale;
    this.save();
  }

  setLayout(layout: string) {
    this.layout = layout;
    this.save();
    void this.layoutHugBoxService.applyHugBoxForLayoutSwitch(
      this.componentId,
      layout,
      this.daysToShow,
    );
  }

  setIconStyle(iconStyle: string) {
    this.iconStyle = iconStyle;
    this.save();
  }
}
